import type { ComponentPropsWithoutRef, CSSProperties } from "react";

import { cx } from "../../lib/cx";
import s from "./Progress.module.css";

export interface ProgressProps extends ComponentPropsWithoutRef<"div"> {
  /** 0 a 100. */
  value?: number;
  /** Qué avanza: "Subiendo foto 2 de 5". Es el `aria-label`. */
  label: string;
  /** Sin porcentaje conocido. */
  indeterminate?: boolean;
  /** Muestra el `label` a la vista, con el porcentaje. */
  showLabel?: boolean;
}

/** Barra fina, sin track pesado. Los datos aparecen en su valor final; esto es lo único que se mueve. */
export function Progress({ value = 0, label, indeterminate = false, showLabel = false, className, style, ...rest }: ProgressProps) {
  const pct = Math.max(0, Math.min(100, Math.round(value)));
  return (
    <div className={cx(s.wrap, className)} {...rest}>
      {showLabel ? (
        <div className={s.texto}>
          <span>{label}</span>
          {!indeterminate ? <span className={s.pct}>{pct}%</span> : null}
        </div>
      ) : null}
      <div
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={indeterminate ? undefined : pct}
        className={s.barra}
        data-indeterminate={indeterminate || undefined}
        style={{ "--_p": `${pct}%`, ...style } as CSSProperties}
      >
        <span className={s.relleno} />
      </div>
    </div>
  );
}
